import { render, staticRenderFns } from "./SolicitudEmpaque.vue?vue&type=template&id=408f0537&scoped=true"
import script from "./SolicitudEmpaque.vue?vue&type=script&lang=js"
export * from "./SolicitudEmpaque.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SolicitudEmpaque.vue?vue&type=style&index=1&id=408f0537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f0537",
  null
  
)

export default component.exports